import { ConnectionService } from './connection.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LineItem } from '@contracts/interfaces/lineitem.interface';
import { Account } from '@contracts/interfaces/account.interface';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

    constructor(private http: HttpClient,
                private connectionService: ConnectionService ) {}

    find(query: any = {}) {
        return this.http.post(this.connectionService.address + "/account-service/find", {
            query
        });
    }

    create(account: Account) {
        return this.http.post(this.connectionService.address + "/account-service/create", {
            account
        });
    }

    update (account: Account) {
        return this.http.post(this.connectionService.address + "/account-service/update", {
            account
        });
    }

    delete (account: Account) {
        return this.http.post(this.connectionService.address + "/account-service/delete", {
            account
        });
    }

    exists (accountNumber: number) {
        return this.http.post(this.connectionService.address + "/account-service/exists", {
            accountNumber
        });
    }

    saveLineItems (lineItems: LineItem[]) {
        return this.http.post(this.connectionService.address + "/account-service/save-line-items", {
            lineItems
        })
    }

    getInvoices (accountNumber: number) {
        return this.http.post(this.connectionService.address + "/account-service/get-invoices", {
            accountNumber
        })
    }
}
